import * as React from 'react';
import { AngleIcon } from 'src/assets/icons/AngleIcon';
import { StyledAnglePicker, StyledHandle, AngleIndicatorContainer, AngleIndicatorText } from './AnglePicker.styled';
import { ThresholdSlider, type ThresholdSliderProps } from './ThresholdSlider';
import { ThresholdIndicator } from './ThresholdIndicator';
import { useAnglePicker, type UseAnglePickerParams } from './useAnglePicker';
import { CardinalDirectionIndicator } from './CardinalDirectionIndicator';

export interface AnglePickerProps extends ThresholdSliderProps, UseAnglePickerParams {
  angle: number;
}

export const AnglePicker: React.FunctionComponent<AnglePickerProps> = ({
  angle,
  onAngleChange,
  thresholdAngle,
  onThresholdChange,
}) => {
  const { containerRef, handleMouseMove, handleMouseUp, handleMouseDown } = useAnglePicker({
    onAngleChange,
  });

  return (
    <>
      <StyledAnglePicker ref={containerRef} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
        <ThresholdIndicator centerAngle={angle} thresholdAngle={thresholdAngle} />
        <StyledHandle $angle={angle} onMouseDown={handleMouseDown}>
          <AngleIcon />
        </StyledHandle>

        <AngleIndicatorContainer>
          <AngleIndicatorText>{angle}°</AngleIndicatorText>
        </AngleIndicatorContainer>

        <CardinalDirectionIndicator />
      </StyledAnglePicker>

      <ThresholdSlider thresholdAngle={thresholdAngle} onThresholdChange={onThresholdChange} />
    </>
  );
};
